import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import FormCheckbox from "../../hook-controls/checkbox";
import Grid from "@material-ui/core/Grid";
//Api
import { GetModuleMasterList } from "../../../module/master/api";

function CheckboxModule(props) {
  const [Data, setData] = useState([]);
  useEffect(() => {
    (async () => {
      let data = await GetModuleMasterList();
      setData(data);
    })();
  }, [setData]);
  return (
    <>
      <Box ml={3} mr={3} display="flex" className="checkboxBox">
        {" "}
        <Box className="checkboxHeader" justifyContent="flex-end">
          <Typography variant="caption" display="block" gutterBottom>
            Module
          </Typography>
        </Box>
        <Grid container spacing={1}>
          <Box
            className="checkboxList"
            display="flex"
            flexWrap="wrap"
            flexGrow={1}
            m={1}
          >
            {Data?.map((el) => (
              <Grid item xs={6} key={el.ID}>
                <FormCheckbox
                  {...props}
                  value={el.MODULE_NAME}
                  label={el.MODULE_NAME}
                />
              </Grid>
            ))}
          </Box>
        </Grid>
      </Box>
    </>
  );
}

export default CheckboxModule;
